import { render } from "./PortfolioNavigationSocialLinkItem.vue?vue&type=template&id=542f6d7f"
import script from "./PortfolioNavigationSocialLinkItem.vue?vue&type=script&lang=js"
export * from "./PortfolioNavigationSocialLinkItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/common/navigation/PortfolioNavigationSocialLinkItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "542f6d7f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('542f6d7f', __exports__)) {
    api.reload('542f6d7f', __exports__)
  }
  
  module.hot.accept("./PortfolioNavigationSocialLinkItem.vue?vue&type=template&id=542f6d7f", () => {
    api.rerender('542f6d7f', render)
  })

}


export default __exports__